import $ from 'jquery';
import '../../vendor/js/modernizr.min.js';
import Vue from '../main/vue';
import router from '../main/vue-routes';
import {getLangcode} from '../main/utils';
import 'ammap3/ammap/ammap';
import 'ammap3/ammap/maps/js/usaLow';

const AmCharts = window.AmCharts;

new Vue({
  el: '.rebate-locator',
  comments: true,
  data: {
    areas: [],
    productRebatesError: false,
    productRebatesLoading: true,
    productRebatesResults: [],
    productRebatesMap: false,
    searchTerm: ''
  },
  computed: {
    langcode() {
      return getLangcode(this.$route.params.langcode);
    },
    endpoint() {
      return `${
        this.langcode !== 'en' ? '/' + this.langcode : ''
      }/rest/product-rebate?_format=json`;
    },
    filteredRebates() {
      if (this.productRebatesResults.length) {
        return this.productRebatesResults.filter(result => {
          return result.field_state
            .toLowerCase()
            .includes(this.searchTerm.toLowerCase());
        });
      }
      return [];
    }
  },
  mounted() {
    this.runQuery();
  },
  methods: {
    setMapAreas() {
      // Create array of states that have rebates
      const rebateStates = [];

      for (let i = 0; i < this.productRebatesResults.length; i++) {
        const rebate = this.productRebatesResults[i];
        const rebateState = rebate.field_state;

        if (rebateStates.indexOf(rebateState) === -1) {
          rebateStates.push(rebateState);
        }
      }

      // Create array of custom areas for map
      const usaLow = AmCharts.maps.usaLow;
      const usaStates = usaLow.svg.g.path;

      for (let j = 0; j < usaStates.length; j++) {
        const state = usaStates[j];
        const area = {
          title: '',
          id: '',
          color: ''
        };

        area.title = state.title;
        area.id = state.id;

        if (rebateStates.indexOf(area.title) === -1)
          area.color = '#fafafa';
        else area.color = '#e4f0f9';
        this.areas.push(area);
      }

      this.initializeMap();
    },
    initializeMap() {
      const map = AmCharts.makeChart('map', {
        type: 'map',
        dataProvider: {
          map: 'usaLow',
          areas: this.areas
        },
        listeners: [
          {
            event: 'clickMapObject',
            method: this.setState
          }
        ],
        zoomControl: {
          zoomControlEnabled: false,
          homeButtonEnabled: false
        },
        areasSettings: {
          unlistedAreasColor: '#fff',
          outlineColor: '#a7c7de',
          rollOverColor: '#fff',
          rollOverOutlineColor: '#a7c7de',
          selectable: true,
          selectedColor: '#fff'
        },
        balloon: {
          fillAlpha: 1,
          shadowAlpha: 0
        }
      });

      this.productRebatesMap = map;
    },
    setState(event) {
      this.searchTerm = event.mapObject.title;
    },
    search() {
      const searchedState = toTitleCase(this.searchTerm);
      const mapAreas = this.productRebatesMap.dataProvider.areas;
      let match = false;

      for (let i = 0; i < mapAreas.length; i++) {
        if (mapAreas[i].title === searchedState) {
          match = true;
          const id = mapAreas[i].id;
          const object = this.productRebatesMap.getObjectById(id);
          this.productRebatesMap.selectObject(object);
        }
      }

      if (match === false) this.productRebatesMap.selectObject();
    },
    runQuery() {
      $.ajax({
        url: this.endpoint
      })
        .done(data => {
          this.productRebatesResults = data.results;
          this.productRebatesError = false;
          this.productRebatesLoading = false;

          this.$nextTick(() => this.setMapAreas());
        })
        .fail(() => {
          this.productRebatesError = true;
          this.productRebatesResults = [];
          this.productRebatesLoading = false;
        });
    }
  },
  router
});

const toTitleCase = str => {
  return str.replace(/\w\S*/g, txt => {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
};
